import { Component, EventEmitter, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { UpcomingChangesDialogData } from './upcoming-changes-dialog.data';
import { UpcomingChangesDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/upcoming-changes-dto';
import { ServiceAftaleService } from 'src/app/api/services/service-aftale.service';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { UpcomingChangesTypeEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/upcoming-changes-type-enum';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RemoveUpcomingChangesRequest } from 'src/app/api/models/OK/Egis/Service/Models/Request/remove-upcoming-changes-request';

@Component({
    selector: 'app-upcoming-changes-dialog',
    templateUrl: './upcoming-changes-dialog.component.html',
    styleUrls: ['./upcoming-changes-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UpcomingChangesDialogComponent implements OnInit {
  upcomingChangesTypeEnum = UpcomingChangesTypeEnum;

  serviceaftale: ServiceaftaleDto;
  upcomingChanges: UpcomingChangesDto;

  sendLetterForm: UntypedFormGroup;

  onReloadData = new EventEmitter();

  constructor(
    private service: ServiceAftaleService,
    private dialog: MatDialogRef<UpcomingChangesDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    private errorHandler: ErrorHandlerService,
    @Inject(MAT_DIALOG_DATA) public data: UpcomingChangesDialogData
  ) {
    this.serviceaftale = data.serviceaftale;
    this.upcomingChanges = data.upcomingChanges;

    this.blockLetter =
      (this.upcomingChanges.hasOpkraevningsintervalChanges || this.upcomingChanges.hasKundeOpkraevningModelChanges) &&
      !this.upcomingChanges.hasTilvalgChanges &&
      !this.upcomingChanges.hasServiceabonnementChanges &&
      !this.upcomingChanges.hasPartnerChanges;

    this.sendLetterForm = this.formBuilder.group({
      sendLetter: [this.blockLetter ? false : true, Validators.required],
    });
  }

  ngOnInit(): void {}

  removeAbonnementChanges() {
    this.showConfirm =
      (this.upcomingChanges.hasOpkraevningsintervalChanges || this.upcomingChanges.hasKundeOpkraevningModelChanges) &&
      !this.upcomingChanges.hasTilvalgChanges &&
      !this.upcomingChanges.hasServiceabonnementChanges &&
      !this.upcomingChanges.hasPartnerChanges
        ? UpcomingChangesTypeEnum.OpkraevningsInterval
        : (this.showConfirm = UpcomingChangesTypeEnum.AbonnementAndTilvalg);
  }

  removePartnerChanges() {
    this.showConfirm = UpcomingChangesTypeEnum.Partner;
  }

  showConfirm: UpcomingChangesTypeEnum;
  blockLetter: boolean;

  confirm() {
    let body: RemoveUpcomingChangesRequest = {
      changesToRemove: this.showConfirm,
      serviceaftaleId: this.serviceaftale.id,
      upcomingChanges: this.upcomingChanges,
      sendLetter: this.sendLetterForm.controls.sendLetter.value,
    };
    this.service
      .removeUpcomingChanges({
        caller: EGIS_SERVICE_CALLER,
        body: body,
      })
      .subscribe({
        next: (v) => {
          this.upcomingChanges = v;
          this.dialog.close(this.upcomingChanges);
        },
        error: (err) => {
          this.errorHandler.HandleError(err);
          this.dialog.close();
        },
      });
  }

  cancel() {
    this.showConfirm = null;
  }

  reloadServiceAftale() {
    this.onReloadData.emit();
  }
}
